import { PaginatedResponse } from '@root/src/types/common';

export const mapPaginatedResponse = <TBack, TFront>(
  data: PaginatedResponse<TBack>,
  mapItem: (item: TBack) => TFront,
): PaginatedResponse<TFront> => ({
  items: data.items.map(mapItem),
  pages: data.pages,
  total: data.total,
});
